const thirdParty = {
  thirdParty: {
    pageHeader: 'Relatórios de terceiros',
    clearState: 'Estado liberado',
    register: 'Registro',
    systemRegistrationSummary: 'Resumo do registro do sistema',
    registrationProgress: '%{registration_in_progress} Em andamento',
    registrationComplete: '%{registration_complete} Completo',
    thirdPartyLogin: 'Faça login como responsável pela unidade para gerenciar sua conta PowerDash.',
    thirdPartyInvalidURI: 'O URI solicitado é inválido ou o recurso solicitado, como um sistema, não existe.'
  }
};

export default thirdParty;
